jQuery(function () {
	var myOffside = offside("#mobileMenu", {
		slidingElementsSelector: "body",
		buttonsSelector: ".menu-toggle, .offcanvas-close, .offcanvas-overlay",
		beforeOpen: function () {
			$(".offcanvas-overlay").fadeIn();
		},
		beforeClose: function () {
			$(".offcanvas-overlay").fadeOut();
		},
	});

	$("header").sticky({
        topSpacing: 0,
        zIndex: 999,
    });

	if ($(window).width() < 1024) {
		$(".has-sub .toggle").on("click", function () {
			$(this).next().slideToggle();
			$(this).toggleClass("ri-arrow-down-s-fill ri-arrow-up-s-fill");
		});
	}

	$(".expand-toggle").on("click", function (e) {
		e.preventDefault();
		$(this).prev().toggleClass("show");
		$(this).find("strong").toggleText("Xem thêm", "Rút gọn");
		$(this)
			.find("span")
			.toggleClass("ri-arrow-down-s-line ri-arrow-up-s-line");
	});

	if ($(".vision-section-1").length > 0) {
		$(".vision-section-1").prepend($(".breadcrumb-wrapper"));
	}

	$(".development-item .title").on("click", function () {
		$(this).next().slideToggle();
		$(this).toggleClass("active");
	});

	if ($(".account ul li").length == 0) {
		$(".account ul").remove();
	}

	$(".back-to-top").on("click", function () {
		$("html, body").animate({ scrollTop: 0 }, 2000);
	});

	collapseComponent();
	imagesSlider();
	uploadImageForm();

	if($('body').hasClass('register-page')) {
		$('.append-form').append($('#register-advise > .row'))
	}

	$.fancybox.defaults.parentEl = "form";

	$(".path-item").on("click", function () {
		var index = $(this).data("index");
		$(this).siblings().removeClass("active");
		$(this).addClass("active");
		$(`.path-detail-item[data-index="${index}"]`).show();
		$(`.path-detail-item[data-index="${index}"]`).siblings().hide();
	});

	$(".step-section .box-choose-product .main-slide").length > 0 &&
		$(".step-section .box-choose-product .main-slide").each(function (e) {
			$(this)
				.addClass("mySwiper-" + e)
				.find(".button-prev")
				.addClass("button-prev-" + e)
				.next()
				.next()
				.addClass("button-next-" + e);
			new Swiper(".step-section .mySwiper-" + e + " .swiper", {
				speed: 500,
				spaceBetween: 10,
				slidesPerView: "auto",
				observer: !0,
				observeParents: !0,
				navigation: {
					nextEl: ".step-section .button-next-" + e,
					prevEl: ".step-section .button-prev-" + e,
				},
				pagination: {
					el: ".step-section .swiper-pagination-" + e,
					clickable: !0,
				},
			});
		});
});

$.fn.extend({
	toggleText: function (a, b) {
		return this.text(this.text() == b ? a : b);
	},
});

function collapseComponent() {
	$(document).on("click", ".collapse-trigger", function () {
		$(this).next().slideToggle();
		$(this).toggleClass("active");
		return false;
	});
}

function uploadImageForm() {
	$(".form-upload".length > 0) &&
		$(".form-upload").each(function (e) {
			var t = e + 1,
				n = document.querySelector("#uploadArea" + t);
			console.log(n);
			var o = document.querySelector("#dropZoon" + t),
				a = document.querySelector("#upload" + t),
				i = document.querySelector("#previewImage" + t),
				r = ["jpeg", "png", "svg", "gif"];
			function s(e) {
				var t = new FileReader();
				(function (e, t) {
					return 0 !==
						r.filter(function (t) {
							return -1 !== e.indexOf("image/".concat(t));
						}).length
						? t <= 2e6 ||
								alert(
									"Vui lĂ²ng chá»n hĂ¬nh cĂ³ dá»¥ng lÆ°á»£ng nhá» hÆ¡n 2MB"
								)
						: alert("Vui lĂ²ng táº£i lĂªn lĂ  tá»‡p hĂ¬nh");
				})(e.type, e.size) &&
					(o.classList.add("drop-zoon--Uploaded"),
					(i.style.display = "none"),
					t.addEventListener("load", function () {
						setTimeout(function () {
							n.classList.add("upload-area-open"),
								(i.style.display = "block");
						}, 500),
							i.setAttribute("src", t.result);
					}),
					t.readAsDataURL(e));
			}
			o.addEventListener("dragover", function (e) {
				e.preventDefault(), o.classList.add("drop-zoon-over");
			}),
				o.addEventListener("dragleave", function (e) {
					o.classList.remove("drop-zoon-over");
				}),
				o.addEventListener("drop", function (e) {
					e.preventDefault(),
						o.classList.remove("drop-zoon-over"),
						s(e.dataTransfer.files[0]);
				}),
				o.addEventListener("click", function (e) {
					a.click();
				}),
				a.addEventListener("change", function (e) {
					s(e.target.files[0]);
				});
		});
}

// let colorType = {
// 	type: "multi"
// };

// let colors = {
// 	color1: "rgba(255,255,255,1)",
// 	color2: "rgba(233,239,250,1)",
// 	color3: "rgba(222,241,250,1)",
// 	color4: "rgba(178,209,219,1)",
// 	color5: "rgba(135,143,145,1)"
// };

// let options = {
// 	alphaSpeed: 2,
// 	alphaVariance: 1,
// 	color: [colors.color1, colors.color2, colors.color3, colors.color4],
// 	composition: "source-over",
// 	count: 100,
// 	direction: 145,
// 	drift: 2,
// 	glow: 50,
// 	imageUrl: [
// 		"https://assets.codepen.io/13471/snowflake.png",
// 		"https://assets.codepen.io/13471/snowflake(1).png",
// 		"https://assets.codepen.io/13471/snowflake(2).png",
// 		"https://assets.codepen.io/13471/snowflake(3).png",
// 		"https://assets.codepen.io/13471/snowflake(4).png",
// 		"https://assets.codepen.io/13471/snowflake(5).png",
// 		"https://assets.codepen.io/13471/snowflake(6).png",
// 		"https://assets.codepen.io/13471/snowflake(7).png",
// 		"https://assets.codepen.io/13471/snowflake(8).png",
// 	],
// 	maxAlpha: 2,
// 	maxSize: 24,
// 	minAlpha: -0.2,
// 	minSize: 3,
// 	parallax: 6,
// 	rotation: 0.5,
// 	shape: ["image"],
// 	speed: 2.5,
// 	style: "fill",
// 	twinkle: false,
// 	xVariance: 20,
// 	yVariance: 20,
// };

// window.onload = function () {
// 	initSparticles();
// }

// window.initSparticles = function () {
// 	var $main = document.querySelector("main");
// 	window.mySparticles = new Sparticles($main, options);
// };

const topMenuMapping = new MappingListener({
	selector: ".header-top-left",
	mobileWrapper: ".offcanvas-wrap",
	mobileMethod: "appendTo",
	desktopWrapper: ".header-left",
	desktopMethod: "prependTo",
	breakpoint: 1024.98,
}).watch();

const menuMapping = new MappingListener({
	selector: ".menu-wrapper",
	mobileWrapper: ".offcanvas-wrap",
	mobileMethod: "appendTo",
	desktopWrapper: ".header-bottom-left",
	desktopMethod: "prependTo",
	breakpoint: 1024.98,
}).watch();

const bannerSlider = new Swiper(".home-banner .swiper", {
	slidesPerView: 1,
	spaceBetween: 15,
	navigation: {
		nextEl: ".home-banner .swiper-next",
		prevEl: ".home-banner .swiper-prev",
	},
});

const memberSlider = new Swiper(".member-slider .swiper", {
	slidesPerView: 1,
	spaceBetween: 15,
	navigation: {
		nextEl: ".member-slider .swiper-next",
		prevEl: ".member-slider .swiper-prev",
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 15,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 30,
		},
	},
});

const partnerSlider = new Swiper(".partner-slider .swiper", {
	slidesPerView: 1,
	spaceBetween: 15,
	loop: true,
	autoplay: {
		delay: 2000,
	},
	navigation: {
		nextEl: ".partner-slider .swiper-next",
		prevEl: ".partner-slider .swiper-prev",
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 15,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 30,
		},
	},
});

const igcContentSlider = new Swiper(".igc-school-section .swiper", {
	slidesPerView: 1,
	spaceBetween: 15,
	navigation: {
		nextEl: ".igc-school-section .swiper-next",
		prevEl: ".igc-school-section .swiper-prev",
	},
});

const introThumbnailsSlider = new Swiper(".intro-thumbnails .swiper", {
	slidesPerView: 2,
	spaceBetween: 10,
	navigation: {
		nextEl: ".intro-images .swiper-next",
		prevEl: ".intro-images .swiper-prev",
	},
	breakpoints: {
		576: {
			slidesPerView: 3,
			spaceBetween: 15,
		},
		768: {
			slidesPerView: 4,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 5,
			spaceBetween: 20,
		},
	},
});

const introImagesSlider = new Swiper(".intro-images .swiper", {
	slidesPerView: 1,
	spaceBetween: 15,
	navigation: {
		nextEl: ".intro-images .swiper-next",
		prevEl: ".intro-images .swiper-prev",
	},
	thumbs: {
		swiper: introThumbnailsSlider,
	},
});

const staffOtherSlider = new Swiper(".staff-other-slider .swiper", {
	slidesPerView: 1,
	spaceBetween: 15,
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
	},
	navigation: {
		nextEl: ".staff-other-slider .swiper-next",
		prevEl: ".staff-other-slider .swiper-prev",
	},
});

const newsSlider = new Swiper(".news-slider .swiper", {
	slidesPerView: 1,
	spaceBetween: 15,
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
	},
	navigation: {
		nextEl: ".news-slider .swiper-next",
		prevEl: ".news-slider .swiper-prev",
	},
});

const videoSlider = new Swiper(".video-slider .swiper", {
	slidesPerView: 1.15,
	spaceBetween: 10,
	loop: true,
	breakpoints: {
		576: {
			slidesPerView: 1.5,
		},
		768: {
			slidesPerView: 2.25,
		},
		1024: {
			slidesPerView: 1.57,
			spaceBetween: -80,
			centeredSlides: true,
			initialSlide: 1,
		},
	},
	navigation: {
		prevEl: ".video-slider .swiper-prev",
		nextEl: ".video-slider .swiper-next",
	},
});

const boardingSlider = new Swiper(".boarding-slider .swiper", {
	slidesPerView: 1.15,
	spaceBetween: 10,
	loop: true,
	breakpoints: {
		576: {
			slidesPerView: 1.5,
		},
		768: {
			slidesPerView: 2.25,
		},
		1024: {
			slidesPerView: 1.57,
			spaceBetween: -80,
			centeredSlides: true,
			initialSlide: 1,
		},
	},
	navigation: {
		prevEl: ".boarding-slider .swiper-prev",
		nextEl: ".boarding-slider .swiper-next",
	},
});

function imagesSlider() {
	$(".images-slider").each(function (index) {
		var $this = $(this);
		$this.addClass("images-slider-" + index);
		$this.find(".swiper-prev").addClass("images-slider-prev-" + index);
		$this.find(".swiper-next").addClass("images-slider-next-" + index);
		$this
			.find(".swiper-pagination")
			.addClass("images-slider-pagination-" + index);

		var imagesSlider = new Swiper(".images-slider-" + index + " .swiper", {
			slidesPerView: 1,
			spaceBetween: 15,
			navigation: {
				prevEl: ".images-slider-prev-" + index,
				nextEl: ".images-slider-next-" + index,
			},
		});
	});
}

const homeFeedbackImgSlider = new Swiper(".feedback-img-slider .swiper", {
	slidesPerView: 1,
	effect: "creative",
	creativeEffect: {
		limitProgress: 2,
		prev: {
			translate: ["-100%", 0, 0],
			opacity: 0,
		},
		next: {
			translate: [30, -30, 0],
		},
	},
});

const homeFeedbackContentSlider = new Swiper(
	".feedback-content-slider .swiper",
	{
		slidesPerView: 1,
		spaceBetween: 15,
		thumbs: {
			swiper: homeFeedbackImgSlider,
		},
		navigation: {
			prevEl: ".feedback-img-slider .swiper-prev",
			nextEl: ".feedback-img-slider .swiper-next",
		},
	}
);

const photoSlider = new Swiper(".photo-slider .swiper", {
	slidesPerView: 1.25,
	spaceBetween: 15,
	navigation: {
		prevEl: ".photo-slider .swiper-prev",
		nextEl: ".photo-slider .swiper-next",
	},
	breakpoints: {
		576: {
			slidesPerView: 2.25,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
	},
});
